// extracted by mini-css-extract-plugin
export default {"bloc":"PostalCodeField_bloc__BS7my","error__message":"PostalCodeField_error__message__w7-70"};